/**
 * Estados que en el listado se ven solo con color/icono y en Excel van
 * como texto entre paréntesis, p. ej. "Proveedor X (Archivado)".
 */

export function isExcelFlagTrue(value) {
  return value === true || value === "true";
}

export function isExcelFlagFalse(value) {
  return value === false || value === "false";
}

export function isPaymentRefField(field) {
  if (!field) return false;
  const ref =
    field.subFieldRef || field.subFieldDef?.ref || field.nestedSubFieldDef?.ref || field.ref;
  return String(ref || "").toLowerCase() === "payment";
}

export function appendExcelMarker(text, marker) {
  const base = text == null ? "" : String(text);
  if (!marker) return base;
  const suffix = ` (${marker})`;
  if (base.includes(suffix)) return base;
  return `${base}${suffix}`;
}

export function appendExcelMarkers(text, markers) {
  return (markers || []).reduce(
    (out, marker) => appendExcelMarker(out, marker),
    text == null ? "" : String(text)
  );
}

/**
 * Marcadores de ciclo de vida / pago a partir de un documento o referencia poblada.
 * @param {Function} t i18n `$t`
 */
export function collectExcelVisualMarkers(entity, t, options = {}) {
  const markers = [];
  if (!entity || typeof entity !== "object" || typeof t !== "function") {
    return markers;
  }
  if (isExcelFlagTrue(entity.deleted)) {
    markers.push(t("listTitleTrash"));
  } else if (isExcelFlagTrue(entity.archived)) {
    markers.push(t("excelExportArchived"));
  }
  if (options.includePaid) {
    if (isExcelFlagTrue(entity.paid)) {
      markers.push(t("excelExportPaid"));
    } else if (isExcelFlagFalse(entity.paid)) {
      markers.push(t("excelExportUnpaid"));
    }
  }
  return markers;
}

export function formatExcelLabelWithVisualStatus(label, entity, t, options = {}) {
  return appendExcelMarkers(label, collectExcelVisualMarkers(entity, t, options));
}

export function wrapExcelIconName(value) {
  if (value == null || value === "") return "";
  const raw = String(value).trim();
  if (!raw) return "";
  if (raw.startsWith("(") && raw.endsWith(")")) return raw;
  return `(${raw})`;
}
